import { largeNumberDisplay } from '@/utils/helpers';

export default {
  props: {
    buyQuantity: {
      type: Number,
      default: 0,
    },
    sellQuantity: {
      type: Number,
      default: 0,
    },
    mode: {
      type: String,
      default: 'yes',
    },
  },
  computed: {
    hasOffers() {
      return this.buyQuantity > 0 || this.sellQuantity > 0;
    },
    buyQuantityFormatted() {
      return this.buyQuantity.toLocaleString('en-US');
    },
    sellQuantityFormatted() {
      return this.sellQuantity.toLocaleString('en-US');
    },
    buyQuantityDisplay() {
      return largeNumberDisplay(this.buyQuantity);
    },
    sellQuantityDisplay() {
      return largeNumberDisplay(this.sellQuantity);
    },
    buyValueClass() {
      return [
        'market-contract-horizontal-sushi-orders__value',
        `market-contract-horizontal-sushi-orders__value--buy-${this.mode || 'yes'}`,
        'market-contract-horizontal-sushi-orders__tooltip',
      ];
    },
    sellValueClass() {
      return [
        'market-contract-horizontal-sushi-orders__value',
        `market-contract-horizontal-sushi-orders__value--sell-${this.mode || 'yes'}`,
        'market-contract-horizontal-sushi-orders__tooltip',
      ];
    },
  },
};
